import { render } from "./BranchBox.vue?vue&type=template&id=f1e1822e&scoped=true"
import script from "./BranchBox.vue?vue&type=script&lang=js"
export * from "./BranchBox.vue?vue&type=script&lang=js"

import "./BranchBox.vue?vue&type=style&index=0&id=f1e1822e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f1e1822e"

export default script